module.exports = __webpack_public_path__ + "img/residencial_eu.5adb7805.png";